<template>
  <div>
    <v-card-text>
      <v-row class="match-height" dense>
        <v-col>
          <div v-if="!unitsDisplay.length" class="mb-1">
            Keine Einsatzmittel zugewiesen
          </div>
          <div v-else class="mb-2">
            <v-row dense class="match-height">
              <v-col
                cols="12"
                v-for="(unit, index) in unitsDisplay"
                :key="index"
              >
                <v-card outlined>
                  <v-row class="match-height" no-gutters>
                    <v-col
                      cols="12"
                      sm="4"
                      :class="
                        $vuetify.breakpoint.xsOnly
                          ? 'd-flex align-self-center'
                          : $vuetify.theme.dark
                          ? 'border-light'
                          : 'border-dark'
                      "
                    >
                      <div class="hidden-xs-only">
                        <p
                          class="px-1 ma-0 text-center font-weight-medium subtitle-2 text-truncate"
                          :class="[
                            $vuetify.theme.dark
                              ? 'white--text grey darken-2'
                              : 'grey lighten-2',
                            $vuetify.breakpoint.xsOnly
                              ? 'rounded-t'
                              : 'rounded-tl',
                          ]"
                        >
                          {{ unit.title }} ({{
                            unit.selectedCrewCombination.title
                          }})
                        </p>
                        <div class="d-flex justify-center flex-grow-0">
                          <v-img
                            contain
                            height="40"
                            width="40"
                            class="ma-1"
                            :src="unit.photoUrl.size200x200"
                          />
                        </div>
                        <p
                          class="px-1 ma-0 text-center font-weight-medium subtitle-2 text-truncate white--text purple"
                          :class="[
                            $vuetify.breakpoint.xsOnly ? '' : 'rounded-bl',
                          ]"
                        >
                          Besetzbarkeit unbekannt
                        </p>
                      </div>
                      <span class="hidden-sm-and-up">
                        <v-list-item>
                          <v-img
                            contain
                            height="40"
                            max-width="110"
                            class="ma-1 mr-4"
                            :src="unit.photoUrl.size200x200"
                          />

                          <!-- <v-list-item-content>
                            <v-list-item-title class="font-weight-medium">
                              {{ unit.title }} ({{
                                unit.selectedCrewCombination.title
                              }})</v-list-item-title
                            ><v-list-item-subtitle
                              ><v-chip
                                x-small
                                color="purple"
                                class="white--text font-weight-medium"
                                >Besetzbarkeit unbekannt</v-chip
                              ></v-list-item-subtitle
                            >
                          </v-list-item-content> -->
                        </v-list-item>

                        <div class="d-flex justify-center flex-grow-0"></div>
                      </span>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="8"
                      class="d-flex align-self-center"
                      :class="[
                        $vuetify.breakpoint.smAndDown
                          ? 'py-2 px-3'
                          : 'py-0 px-3',
                      ]"
                    >
                      <v-row dense class="match-height">
                        <v-col
                          cols="4"
                          sm="2"
                          md="2"
                          lg="2"
                          v-for="(position, index) in unit
                            .selectedCrewCombination.positions"
                          :key="index"
                          class="align-self-center"
                        >
                          <v-card
                            outlined
                            :color="
                              $vuetify.theme.dark
                                ? 'grey darken-2'
                                : 'grey lighten-3'
                            "
                            max-height="95px"
                            class="text-center d-flex justify-center align-center"
                            :light="!$vuetify.theme.dark"
                            :dark="$vuetify.theme.dark"
                          >
                            <v-card-text class="pa-0 px-0">
                              <div>
                                <div
                                  class="font-weight-medium"
                                  :class="[
                                    $vuetify.breakpoint.smAndDown
                                      ? 'text-h6 mb-n2'
                                      : 'text-h5 ',
                                  ]"
                                >
                                  {{ position.availableCounter }}
                                </div>
                                <div
                                  class="subtitle-2 font-weight-regular text--darken-4"
                                >
                                  {{ position.position.shortTitle }}
                                </div>
                                <v-chip
                                  x-small
                                  color="purple"
                                  class="font-weight-medium white--text mt-n2 mx-1 px-2"
                                  ><v-icon x-small class="hidden-md-only"
                                    >mdi-circle</v-icon
                                  >{{
                                    position.availableCounter -
                                      position.requiredCounter >=
                                    0
                                      ? ""
                                      : position.availableCounter -
                                        position.requiredCounter
                                  }}</v-chip
                                >
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
import { db } from "@/firebase";
export default {
  name: "scheduling-event-unit-forecast-card-content",
  props: {
    requestedUnits: {
      type: Array,
      required: true,
      default: () => [],
    },
    availablePersonnel: {
      type: Array,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      units: [],
    };
  },
  computed: {
    unitsDisplay() {
      // for each item in "this.requestedUnits" -> find the matching unit in "this.units"; then for the correct matching unit look inside crewCombinations and return only the item with the id of the requestedCrewCombination
      if (!this.units.length) {
        return [];
      }
      return this.requestedUnits.map((requestedUnit) => {
        const unitData = this.units.find(
          (unit) => unit.meta.id === requestedUnit.id
        );
        const selectedCrewCombination = unitData.crewCombinations.find(
          (crewCombination) =>
            crewCombination.id === requestedUnit.crewCombination.id
        );
        if (!selectedCrewCombination) {
          console.warn(
            `No matching crew combination found for unit ID: ${requestedUnit.id}`
          );
          return requestedUnit;
        }
        return {
          ...requestedUnit,
          ...unitData,
          selectedCrewCombination: {
            ...selectedCrewCombination,
            positions: selectedCrewCombination.positions
              .filter((position) => !position.isOptional)
              .map((position) => {
                return {
                  ...position,
                  availableCounter: this.availablePersonnel.filter((person) =>
                    person.user.fillablePositions.ids.includes(
                      position.position.id
                    )
                  ).length,
                  requiredCounter: 1,
                };
              }),
          },
        };
      });
    },
  },
  created() {
    this.getRequestedUnits();
  },
  methods: {
    async getRequestedUnits() {
      try {
        const requestedUnitsFiltered = this.requestedUnits.filter(
          (unit, index, self) =>
            index === self.findIndex((u) => u.id === unit.id)
        );
        const units = [];
        for (const unit of requestedUnitsFiltered) {
          const unitDoc = await db
            .collection("organizations")
            .doc(this.$route.params.organizationId)
            .collection("units")
            .doc(unit["id"])
            .get();
          if (unitDoc.exists) {
            units.push({ id: unitDoc.id, ...unitDoc.data() });
          }
        }
        this.units = units;
      } catch (error) {
        console.error("Error fetching requested units:", error);
        return [];
      }
    },
  },
};
</script>
